/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_ContentsInputs */

const zh_course_contents = /** @type {(inputs: Course_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的内容`)
};

const en_course_contents = /** @type {(inputs: Course_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Content`)
};

const es_course_contents = /** @type {(inputs: Course_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi Contenido`)
};

/**
* | output |
* | --- |
* | "My Content" |
*
* @param {Course_ContentsInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const course_contents = /** @type {((inputs?: Course_ContentsInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_ContentsInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_contents(inputs)
	if (locale === "en") return en_course_contents(inputs)
	return es_course_contents(inputs)
});